module.exports = "/_next/static/resources/blavka-1-845f599a6956ffd58583493db5028cf1.webp";